const SET_PODCAST = 'global/podcast/SET_PODCAST';
const SET_PROFILE_COLOR = 'SET_PROFILE_COLOR';

export default {
  SET_PODCAST,
  SET_PROFILE_COLOR,
};
